import orderBy from "lodash/orderBy";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { storageUrlWithCredentials } from "../imagesPreview/storageUrlWithCredentials";

interface Image {
  readonly name: string;
  readonly url: string | undefined;
}

const ImagePreview: FC<{ image: Image; maxWidth: number }> = ({ image, maxWidth }) => {
  const height = (maxWidth * 2) / 3;

  return (
    <div>
      <img
        alt={image.name}
        src={image.url}
        width={maxWidth}
        height={height}
        style={{ objectFit: "cover", objectPosition: "center" }}
      />
    </div>
  );
};

interface Props {
  readonly images: Image[];
  readonly maxWidth: number;
}

const ImagesGallery: FC<Props> = ({ images, maxWidth }) => {
  const [signedImages, setSignedImages] = useState<Image[]>([]);

  useEffect(() => {
    Promise.all(
      images.map((i, idx) => storageUrlWithCredentials(i.url).then((url) => ({ name: i.name, url, idx }))),
    ).then((images) => setSignedImages(orderBy(images, (i) => i.idx)));
  }, [images]);

  const handleClick = (idx: number) => window.open(signedImages[idx].url, "_blank");

  if (signedImages.length === 0) {
    return null;
  }

  return (
    <Carousel axis="horizontal" dynamicHeight={false} infiniteLoop onClickItem={handleClick}>
      {signedImages.map((i) => (
        <ImagePreview key={i.name} image={i} maxWidth={maxWidth} />
      ))}
    </Carousel>
  );
};

export default ImagesGallery;
